/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/resources/address';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "Individual": {
                    "fields": {
                      "givenName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "surname": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "address": {
                        "type": ".squareup.connect.v2.resources.Address",
                        "id": 3,
                        "rule": "optional"
                      },
                      "birthYear": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "ssnLast4": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "idvAttemptsRemaining": {
                        "type": "int32",
                        "id": 7,
                        "rule": "optional"
                      },
                      "birthDate": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "isManager": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      },
                      "hasSignificantOwnership": {
                        "type": "bool",
                        "id": 10,
                        "rule": "optional"
                      },
                      "id": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.Individual) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents an individual on an SFS ApplicationFlow.
 * --
 *
 * SOURCE Individual @ squareup/sfs/external/models/individual.proto at 12:1
 */
export const Individual = $root.lookupType('squareup.sfs.external.models.Individual');
fixType(Individual);
Builder.createAndAttachToType(Individual);